export class MMBDatalayerConstants {
    public static DATALAYER_MMB_INFO = {
        AVIOS_EARNED: 'AviosEarned',
        CHANGE_ACCEPTANCE: 'ChangeAcceptance',
        CHANGE_TYPE: 'ChangeType',
        FLIGHT_STATUS: 'FlightStatus',
        ORIGINAL_ADVANCE_PURCHASE: 'OriginalAdvancePurchase',
        ORIGINAL_DATE: 'OriginalDate',
        ORIGINAL_LENGTH_STAY: 'OriginalLengthStay',
        PNR_TYPE: 'PNRType',
        PURCHASE_DATE: 'PurchaseDate',
        PURCHASE_TYPE: 'PurchaseType',
        SLICE1_ORIGINAL_DATE: 'Slice1OriginalDate',
        SLICE2_ORIGINAL_DATE: 'Slice2OriginalDate',
        SLICE3_ORIGINAL_DATE: 'Slice3OriginalDate',
        SLICE4_ORIGINAL_DATE: 'Slice4OriginalDate',
        SPECIAL_MEAL: 'SpecialMeal',
        PRODUCTS: 'products',
        TOTAL_PRICE: 'TotalPrice',
    };
    public static DATALAYER_MMB_VALUES = {
        YES: 'SI',
        NO: 'NO',
        TOTAL: 'total',
        PARTIAL : 'parcial',
        VOLUNTARY: 'voluntario',
        INVOLUTARY: 'involuntario'
    };
    public static DIGITAL_DATA_PROCESS = {
        MOAPIS: 'servicing',
        MOEMER: 'servicing',
        MOCONT: 'servicing',
        MOFFLY: 'servicing',
        MOPMR: 'servicing',
        MOCAPI: 'servicing',
        MOCEME: 'servicing',
        MOINFO: 'servicing',
        MOCFFL: 'servicing',
        MOCPMR: 'servicing',
		MODSEA: 'ancillaries',
        MODBAG: 'ancillaries',
		MODPAX: 'servicing',
		MODDOC: 'servicing',
        IBMTFL: 'servicing',
        IBENIT: 'servicing',
        IBCENIT: 'servicing',
        CONOMB: 'servicing',
        CONOOK: 'servicing',
        CONKOU: 'servicing',
        CONKOS: 'servicing',
        OHMTDT: 'confirmacion onhold',
        CNCLIT: 'reserva onhold',
        OHINFO: 'confirmacion onhold',
        RTBKCF: 'confirmacion onhold',
        ATCFCNA: 'cambios voluntarios',
        ATCFOW: 'cambios voluntarios',
        ATCFRT: 'cambios voluntarios',
        ATCERD: 'cambios voluntarios',
        ATCPOW: 'cambios voluntarios',
        ATCPRT: 'cambios voluntarios',
        ATCERR: 'cambios voluntarios',
        ATCERT: 'cambios voluntarios',
        ATCSUM: 'cambios voluntarios',
        ATCPURC: 'cambios voluntarios',
        ATCBKCF: 'involuntario con alternativa',
        ATCBKER: 'cambios voluntarios',
        ATCPSG: 'cambios voluntarios',
        CVFFOW: 'cambios voluntarios flexibles',
        CVFFRT: 'cambios voluntarios flexibles',
        CVFERD: 'cambios voluntarios flexibles',
        CVFERB: 'cambios voluntarios flexibles',
        CVFPOW: 'cambios voluntarios flexibles',
        CVFPRT: 'cambios voluntarios flexibles',
        CVFPSG: 'cambios voluntarios flexibles',
        CVFERR: 'cambios voluntarios flexibles',
        CVFERS: 'cambios voluntarios flexibles',
        CVFERF: 'cambios voluntarios flexibles',
        CVBKCF: 'cambios voluntarios flexibles',
        CIFFOW: 'cambio involuntario flex',
        CIFFRT: 'cambio involuntario flex',
        CIFERB: 'cambio involuntario flex',
        CIFPOW: 'cambio involuntario flex',
        CIFPRT: 'cambio involuntario flex',
        CIFPSG: 'cambio involuntario flex',
        CIFERD: 'cambio involuntario flex',
        CIFERR: 'cambio involuntario flex',
        CIFERS: 'cambio involuntario flex',
        CITSUM: 'cambio involuntario flex',
        CIPSUM: 'cambio involuntario flex',
        CIFSUM: 'cambio involuntario flex',
        CIFPURC: 'cambio involuntario flex',
        CIWARN: 'cambio involuntario flex',
        CIBKCF: 'cambio involuntario flex',
        CIBKER: 'cambio involuntario flex',
        CITORE: 'cambios involuntarios flex total',
        CITOAV: 'cambios involuntarios flex total',
        CITOAC: 'cambios involuntarios flex total',
        CITOBK: 'cambios involuntarios flex total',
        CIPARE: 'cambios involuntarios flex parcial',
        CIPAAV: 'cambios involuntarios flex parcial',
        CIPTAV: 'cambios involuntarios flex parcial',
        CIPAAC: 'cambios involuntarios flex parcial',
        CIPTAC: 'cambios involuntarios flex parcial',
        CIPABK: 'cambios involuntarios flex parcial',
        CIPTBK: 'cambios involuntarios flex parcial',
        IBICFC: 'cambios involuntarios sin alternativa',
        IBICHC: 'cambio de hora',
        CINTRE: 'cambios involuntarios sin alternativa',
        CINTBK: 'cambios involuntarios sin alternativa',
        CINPRE: 'cambios involuntarios sin alternativa parcial',
        CINPBK: 'cambios involuntarios sin alternativa parcial',
        SUPUJA: 'pujas upg',
        SUPURC: 'pujas upg',
        SUCONF: 'pujas upg',
        MOANCI: 'ancillaries',
        MOSEAT: 'ancillaries',
        MOSEATJBR: 'ancillaries',
        SEATMPJBR: 'ancillaries',
        MOPRIO: 'ancillaries',
        MOBAGG: 'ancillaries',
        MOLUGG: 'ancillaries',
        MOMEAL: 'ancillaries',
        MEALCF: 'ancillaries',
        MOPURC: 'ancillaries',
        MOBKCF: 'ancillaries',
        IBMCYT: 'ancillaries',
        MODBOB: 'ancillaries',
        MOFLEX: 'ancillaries',
        MODINS: 'ancillaries',
        MOUPG: 'ancillaries',
        MODGCA: 'ancillaries',
        PAYINF: 'ancillaries',
        RVFCFM: 'reembolso flexibilizacion bono',
        MODDIM: 'ancillaries',
        RVFDBT: 'reembolso flexibilizacion',
        RVFDBD: 'reembolso flexibilizacion',
        RVFSMB: 'reembolso flexibilizacion',
        RVFTYC: 'reembolso flexibilizacion',
        RVFCEB: 'reembolso flexibilizacion',
        RVFCFP: 'reembolso flexibilizacion',
        RCFDBD: 'reembolso flexibilizacion',
        RCFCEB: 'reembolso flexibilizacion',
        RCFCFP: 'reembolso flexibilizacion',
        RVDDBT: 'reembolso disrupcion',
        RVDDBD: 'reembolso disrupcion',
        RVDSMB:'reembolso disrupcion',
        RVDTYC: 'reembolso disrupcion',
        RVDCEB: 'reembolso disrupcion',
        RVDCFP: 'reembolso disrupcion',
        RVDCFM: 'reembolso disrupcion',
        RCDDBD: 'reembolso disrupcion',
        RCDCEB: 'reembolso disrupcion',
        RCDCFP: 'reembolso disrupcion',
        TCADVS: 'cambio vuelo pa',
        TCFLPA: 'cambio vuelo pa',
        TCFREV: 'cambio vuelo pa',
        FACGDR: 'servicing',
        FACLIS: 'servicing',
        FACLISF: 'servicing',
        FACRES: 'servicing',
        FACSOK: 'servicing',
        FACSOL: 'servicing',
        FACEMT: 'servicing',
        FACROK: 'servicing',
        FACSKO: 'servicing',
        FACPKO: 'servicing',
        FACRKO: 'servicing',

        //SIMULATOR
        STCFOW: 'simulador cambios voluntarios',
        STCFRT: 'simulador cambios voluntarios',
        STCERD: 'simulador cambios voluntarios',
        STCPOW: 'simulador cambios voluntarios',
        STCPRT: 'simulador cambios voluntarios',
        STCERR: 'simulador cambios voluntarios',
        STCERT: 'simulador cambios voluntarios',
        STCSUM: 'simulador cambios voluntarios'
    };
    public static DIGITAL_DATA_STEP = {
        MOAPIS: 'apis',
        MOEMER: 'emergencias',
        MOCONT: 'contacto',
        MOFFLY: 'frequent flyer',
        MOPMR: 'asistencia',
        MOCAPI: 'confirmacion apis',
        MOCEME: 'confirmacion emergencias',
        MOINFO: 'info',
        MOCFFL: 'confirmacion frequent flyer',
        MOCPMR: 'confirmacion asistencia',
        MODPAX: 'info pasajeros',
        IBMTFL: 'tus vuelos',
        MODDOC: 'documentacion',
        IBENIT: 'envio intinerario',
        IBCENIT: 'confirmacion envio intinerario',
        OHMTDT: 'recuperacion',
        CNCLIT: 'cancelacion',
        OHINFO: 'pago',
        RTBKCF: 'confirmacion',
        ATCFCNA: 'no disponible',
        ATCFOW: 'inicio',
        ATCFRT: 'inicio',
        ATCERD: 'error busqueda',
        ATCPOW: 'disponibilidad OW',
        ATCPRT: 'disponibilidad RT',
        ATCERR: 'error ribbon',
        ATCERT: 'error seleccion',
        ATCSUM: 'resumen',
        ATCPURC: 'pago',
        ATCBKCF: 'confirmacion',
        ATCBKER: 'comunicacion cortada',
        ATCPSG: 'sesion expirada',
        CVFFOW: 'recuperacion ow',
        CVFFRT: 'recuperacion rt',
        CVFERD: 'error seleccion',
        CVFERB: 'blackout',
        CVFPOW: 'disponibilidad ow',
        CVFPRT: 'disponibilidad rt',
        CVFPSG: 'disponibilidad parcial',
        CVFERR: 'error disponibilidad',
        CVFERS: 'error rebook',
        CVFERF: 'error rebook',
        CVBKCF: 'confirmacion',
        CIFFOW: 'recuperacion reserva',
        CIFFRT: 'inicio rt',
        CIFERB: 'blackout',
        CIFPOW: 'disponibilidad ow',
        CIFPRT: 'disponibilidad rt',
        CIFPSG: 'disponibilidad trayecto rt',
        CIFSUM: 'resumen',
        CITSUM: 'resumen',
        CIPSUM: 'resumen',
        CIFPURC: 'pago',
        CIFERD: 'fallo disponibilidad',
        CIFERR: 'error disponibilidad',
        CIFERS: 'error tarificador',
        CIWARN: 'fallo cambio',
        CIBKCF: 'confirmacion',
        CIBKER: 'comunicacion cortada',
        CITORE: 'recuperacion',
        CITOAV: 'disponibilidad',
        CITOAC: 'seleccion',
        CITOBK: 'confirmacion',
        CIPARE: 'recuperacion reserva',
        CIPAAV: 'disponibilidad ow',
        CIPTAV: 'disponibilidad rt',
        CIPAAC: 'seleccion ow',
        CIPTAC: 'seleccion rt',
        CIPABK: 'confirmacion ow',
        CIPTBK: 'confirmacion rt',
        IBICFC: 'recuperacion sin alternativa',
        IBICHC: 'recuperacion reserva',
        CINTRE: 'recuperacion total',
        CINTBK: 'aceptacion total',
        CINPRE: 'recuperacion parcial',
        CINPBK: 'aceptacion parcial',
        SUPUJA: 'puja',
        SUPURC: 'pago',
        SUCONF: 'confirmacion',
        MOANCI: 'inicio',
        MODSEA: 'modal asientos',
        MODBAG: 'modal equipaje',
        MOSEAT: 'asientos',
        MOSEATJBR: 'asientos',
        SEATMPJBR: 'modal asientos',
        MMBEXP: 'sesion expirada',
        MOPRIO: 'prioridad embarque',
        MOBAGG: 'equipaje',
        MOLUGG: 'equipajes especiales',
        MOMEAL: 'comida',
        MEALCF: 'comida confirmada',
        MOPURC: 'pago',
        MOBKCF: 'confirmacion',
        IBMCYT: 'hoteles coches',
        MODBOB: 'recogida equipaje',
        MOFLEX: 'billete flexible',
        MODINS: 'seguro',
        MOUPG: 'upg',

        RVFDBT: 'inicio',
        RVFDBD: 'desglose',
        RVFSMB: 'informacion',
        RVFTYC: 'condiciones',
        RVFCEB: 'aceptacion',
        RVFCFP: 'confirmacion',
        RCFDBD: 'desglose',
        RCFCEB: 'aceptacion',
        RCFCFP: 'confirmacion',
        RVFCFM: 'confirmacion',

        RVDDBT: 'inicio',
        RCDDBD: 'desglose',
        RCDCEB: 'aceptacion',
        RCDCFP: 'confirmacion',

        RVDDBD: 'desglose',
        RVDSMB: 'informacion',
        RVDTYC: 'condiciones',
        RVDCEB: 'aceptacion',
        RVDCFP: 'confirmacion',
        RVDCFM: 'confirmacion bono',

        TCADVS: 'buscador',
        TCFLPA: 'listado vuelos',
        TCFREV: 'nuevo vuelo',
        CONOMB: 'correccion nombre',
        CONOOK: 'confirmacion correccion nombre',
        CONKOU: 'error usuario correccion nombre',
        CONKOS: 'error servicio correccion nombre',
        FACGDR: 'principal reserva',
        FACLIS: 'listado factura',
        FACLISF: 'listado factura',
        FACRES: 'resumen factura',
        FACSOK: 'factura solicitada',
        FACSOL: 'modal factura solicitada',
        FACEMT: 'modal factura emitida',
        FACROK: 'modal factura reenviada',
        FACSKO: 'error resumen',
        FACPKO: 'error listado',
        FACRKO: 'error reenvio',
        MODGCA: 'modal propuesta gastronómica',
        MODDIM: 'digital menu',
        REFVKO: 'error proveedor',
        REFVDB: 'dashboad',
        REFVRE: 'resumen',
        REFVCO: 'confirmacion modal',
        REFVER: 'error',
        REFVBK: 'confirmacion',
        REFVEX: 'abandono',
        PAYINF: 'pago',

        //SIMULATOR
        STCFOW: 'inicio',
        STCFRT: 'inicio',
        STCERD: 'error busqueda',
        STCPOW: 'disponibilidad',
        STCPRT: 'disponibilidad',
        STCERR: 'error ribbon',
        STCERT: 'error seleccion',
        STCSUM: 'resumen'

    };
    public static DIGITAL_DATA_REFUND_PROCESS_BY_PAYMENT_ITEM = {
        VOL_REFUND_OBTAINING: 'reembolso voluntario obtencion',
        VOL_REFUND_OBTAINING_BOND: 'reembolso voluntario obtencion bono',
        VOL_REFUND_OBTAINING_CASHAVIOS: 'reembolso voluntario obtencion  cashavios',
        VOL_REFUND_OBTAINING_REDENTION: 'reembolso voluntario redencion'
    };
    public static DIGITAL_DATA_REFUND_PROCESS_BY_TYPE = {
        PENALTY: 'penalizado',
        WITHOUT_PENALTY: 'sin penalización',
        QUALITY_COMMITMENT: 'compromiso calidad'
    };
    public static DatalayerBKIConstants = {
        MEMBER: 'Member',
        SEARCH_OD: 'SearchOD',
        SEARCH_COUNTRIES: 'SearchCountries',
        SEARCH_CITY: 'SearchCity',
        SEARCH_COUNTRY: 'SearchCountry',
        SEARCH_DEST: 'SearchDest',
        SEARCH_DEST_NAME: 'SearchDestName',
        SEARCH_ORIGIN: 'SearchOrigin',
        SEARCH_ORIGIN_NAME: 'SearchOriginName',
        SEARCH_TYPE: 'SearchType',
        FLIGHT_HAUL: 'FlightHaul',
        FLIGHT_TYPE: 'FlightType',
        // OUTBOUND_ROUTE: 'OutboundRoute',
        // INBOUND_ROUTE: 'InboundRoute',
        // OUTBOUND_FARE_FAMILY: 'OutboundFareFamily',
        // INBOUND_FARE_FAMILY: 'InboundFareFamily',
        // CABIN: 'Cabin',
        // OUTBOUND_CABIN: 'OutboundCabin',
        // INBOUND_CABIN: 'InboundCabin',
        // FARE_NAME: 'FareName',
        // OUTBOUND_FARE_NAME: 'OutboundFareName',
        // INBOUND_FARE_NAME: 'InboundFareName',
        CHEAPEST_FARE: 'CheapestFare',
        // STOPOVER: 'Stopover',
        // OUTBOUND_STOPOVER: 'OutboundStopover',
        // INBOUND_STOPOVER: 'InboundStopover',
        // FLIGHT_SCHEDULE: 'FlightSchedule',
        // OUTBOUND_FLIGHT_SCHEDULE: 'OutboundFlightSchedule',
        // INBOUND_FLIGHT_SCHEDULE: 'InboundFlightSchedule',
        // IDENTIFIER: 'Identifier',
        // OUTBOUND_FLIGHTS: 'OutboundFlights',
        // INBOUND_FLIGHTS: 'InboundFlights',
        // FLIGHTS_OPERATOR: 'FlightOperator',
        // OUTBOUND_OPERATOR: 'OutboundOperator',
        // INBOUND_OPERATOR: 'InboundOperator',
        // OUTBOUND_RESULTS: 'OutboundResults',
        // INBOUND_RESULTS: 'IntboundResults',
        // FLIGHT_DATE: 'FlightDate',
        // OUTBOUND_DATE: 'OutboundDate',
        // INBOUND_DATE: 'InboundDate',
        ADVANCE_PURCHASE: 'AdvancePurchase',
        LENGTH_STAY: 'LengthStay',
        LARGE_FAMILY: 'LargeFamily',
        RESIDENT_CODE: 'ResidentCode',
        PAX_YOUNG: 'PaxYoung',
        PAX_ADULT: 'PaxAdult',
        PAX_INFANT: 'PaxInfant',
        PAX_CHILD: 'PaxChild',
        PAX_SENIOR: 'PaxSenior',
        PAX_TOTAL: 'PaxTotal',
        DYNAMIC_PRICING: 'DynamicPricing',
        DYNAMIC_PRICING_SEAT: 'Dynamic_pricing_seat',
        PROCESS_START: 'ProcessStart',
        IBPLUS_HOLDER: 'IbplusHolder',
        PAX_PRICE: 'PaxPrice',
        TOTAL_PRICE: 'TotalPrice',
        TOTAL_PRICE_WITHOUT_TAXES: 'TotalPriceWithoutTaxes',
        TOTAL_TAXES: 'TotalTaxes',
        ELIGIBLE_VOUCHER: 'EligibleVoucher',
        RECOVERY_LINK: 'RecoveryLink',
        PROVIDER: 'Provider',
        CASH_AVIOS_OFFER: 'CashAviosOffer',
        VOUCHER_CODE_MERGED: 'VoucherCodeMerged',
        VOUCHER_CODE_TO_UNIFY: 'VoucherCodeToUnify',
        MERGED_BONUS_BALANCE: 'MergedBonusBalance',
        VOUCHER_RECORD: 'VoucherRecord',
        PRICE_PAID: 'PricePaid',
        POLICY: 'Policy',
        INSURANCE_TYPE: 'InsuranceType',
        INSURANCE_PRICE: 'InsurancePrice',
        FLEXIBLE_TICKET: 'FlexibleTicket',
        TOTAL_FLEXIBLE_TICKET: 'TotalFlexibleTicket',
        BOARDING_PRIORITY: 'BoardingPriority',
        TOTAL_BOARDING_PRIORITY: 'TotalBoardingPriority',
        STOPOVER_LEG: 'StopoverLeg',
        NIGHTS: 'Nights',
        PMR: 'pmr',
        AVIOS_DISCOUNT: 'AviosDiscount',
        VOUCHER_DISCOUNT: 'VoucherDiscount',
        GIFT_CARD: 'GiftCard',
        TOTAL_PRICE_GIF_CARD: 'TotalPriceGifCard',
        REFERENCE_GIF_CARD: 'ReferenceGifCard',
        EXPIRY_GIF_CARD: 'ExpiryGifCard',
        BENEFICIARY_GIF: 'BeneficiaryGift',
        IBP_BUSINESS_SCORING: 'ibp_business_scoring',
        IBP_LEISURE_SCORING: 'ibp_leisure_scoring',
        SLICE_1_RESULTS: 'Slice1Results',
        SLICE_2_RESULTS: 'Slice2Results',
        OFFERDEST: 'OfferDest',
        OFFERDESTNAME: 'OfferDestName',
        PROCESS: 'Process',
        AVIOS_EARNED: 'AviosEarned',
        PURCHASE_TYPE: 'PurchaseType'
    };
    public static DATALAYER_USER_STATES = {
        LOGGED: 'logado',
        ANONYMOUS: 'no_logado',
        LOGGED_ONB: 'logado_pyme',
        LOGGED_MAIL: 'logado_mail',
        LOGGED_FF: 'logado_ff',
        LOGGED_IB: 'logado_ib',
        LOGGED_FF_HARD: 'logado_ff_hard',
        LOGGED_FF_SOFT: 'logado_ff_soft',
        LOGGED_IB_HARD: 'logado_ib_hard',
        LOGGED_IB_SOFT: 'logado_ib_soft'
    };
    public static DATALAYER_USER_LEVELS = {
        KIDS: 2,
        CLASICA: 2,
        PLATA: 5,
        ORO: 1,
        INFINITA: 4,
        'INFINITA PRIME': 4,
        'PLATINO PRIME': 4,
        PLATINO: 4,
        COLECTIVOS: 'Colectivos',
        COLECTIVO: 'Colectivo',
        PSEUDOAGENCIA: 'PseudoAgencia',
        SERVIWEB: 'Serviweb'
    };
    public static DATALAYER_PASSENGER_TYPES = {
        INFANT: 'INF',
        CHILD: 'CHD',
        YOUTH: 'YTH',
        MINOR: 'MNR',
        STUDENT: 'STD',
        YOUNG_ADULT: 'YCD',
        ADULT: 'ADT',
        SENIOR: 'SNR'
    };
    public static DATALAYER_MODAL_ID = {
        BACK_MODAL: 'BACK_MODAL',
        BACK_MAIN_HEADER_MODAL: 'BACK_MAIN_HEADER_MODAL',
        SHOW_ONHOLD_MODAL: 'SHOW_ONHOLD_MODAL',
        POSIBLE_DELETE_SEGMENT: 'POSIBLE_DELETE_SEGMENT',
        FARE_CONDITIONS: 'FARE_CONDITIONS',
        WHERE_IS_PNR: 'WHERE_IS_PNR',
        PRIVATE_BROWSER_ERROR: 'PRIVATE_BROWSER_ERROR',
        CANCEL_SPECIAL_NEEDS_CONFIRMATION: 'CANCEL_SPECIAL_NEEDS_CONFIRMATION',
        ADVICE_PA_BOOKING: 'ADVICE_PA_BOOKING',
        INFO_CONFIDENTIALITY: 'INFO_CONFIDENTIALITY',
        CHECKIN_ONLINE_MORE_INFO: 'CHECKIN_ONLINE_MORE_INFO',
        BAGGAGE_POLICY: 'BAGGAGE_POLICY',
        BAGGAGE_WARNING: 'BAGGAGE_WARNING',
        SEGMENT_BAGGAGE_SUMMARY: 'SEGMENT_BAGGAGE_SUMMARY',
        BOARDING_CARD_AT_LEAST_ONE_SEND_TYPE_WARNING: 'BOARDING_CARD_AT_LEAST_ONE_SEND_TYPE_WARNING',
        BOARDING_CARD_AT_LEAST_ONE_FORMAT_WARNING: 'BOARDING_CARD_AT_LEAST_ONE_FORMAT_WARNING',
        BOARDING_CARD_FINISH_CHECKIN: 'BOARDING_CARD_FINISH_CHECKIN',
        BAGGAGE_RESTRICTIONS: 'BAGGAGE_RESTRICTIONS',
        ACCEPT_FORBIDDEN_ITEMS: 'ACCEPT_FORBIDDEN_ITEMS',
        AT_LEAST_ONE_PASSENGER_WARNING: 'AT_LEAST_ONE_PASSENGER_WARNING',
        EXCEDED_TOTAL_PASSENGER_WARNING: 'EXCEDED_TOTAL_PASSENGER_WARNING',
        NO_PREVIOUS_SEGMENT_WARNING: 'NO_PREVIOUS_SEGMENT_WARNING',
        SEGMENT_IN_GROUP_WARNING: 'SEGMENT_IN_GROUP_WARNING',
        PAYMENTS_TERMS_AND_CONTRACT_CONDITIONS: 'PAYMENTS_TERMS_AND_CONTRACT_CONDITIONS',
        PAYMENTS_CVV: 'PAYMENTS_CVV',
        BOOKING_SPLIT: 'BOOKING_SPLIT',
        PENDING_PEYMENTS: 'PENDING_PEYMENTS',
        GIFT_CARDS_BACK: 'GIFT_CARDS_BACK',
        STATE: {
            BLANKSPACE: ' '
        },
        PAYMENT_ERRORS: {
            BOOKING: {
                CREDITCARD_DENIED: 'IBCCDN',
                CREDITCARD_REJECT: 'IBREJC',
                CREDITCARD_PCC: 'IBPCC',
                BIN_VALIDATION_ERROR: 'IBPURM'
            },
            MANAGEMYBOOKING_ANCILLARIES: {
                CREDITCARD_DENIED: 'MOCCDN',
                CREDITCARD_REJECT: 'MOREJC'
            },
            MANAGEMYBOOKING_VOLUNTARY_CHANGES: {
                CREDITCARD_DENIED: 'ATCCCDN',
                CREDITCARD_REJECT: 'ATCREJC',
                CREDITCARD_PCC: 'ATCPCC'
            }
        }
    };
    public static DATALAYER_INFO = {
        LANGUAGE: 'idioma',
        MARKET: 'mercado',
        USER_STATE: 'EstadoUsuario',
        QUADRIGAM: 'quadrigam',
        QUADRIGAM_ON_BUSINESS: 'CIP',
        CODE: 'codigoSeguimiento',
        CODE_TRACKING: 'usuarioColectivo',
        WEB_VERSION: 'versionWeb',
        WEB_MODE: 'modeWeb',
        USER_LEVEL: 'NivelUsuario',
        USER_ID: 'userID',
        USER_SEGMENT: 'segmento',
        IS_AIR_SHUTTLE: 'puenteAereo',
        ROUND_TRIP: 'idavuelta',
        ORIGIN_DESTINATIONS: 'trayectoAeropuerto',
        PASSENGER_TYPES: 'tipoPax',
        TOTAL_PASSENGERS: 'numeroPax',
        SEGMENT_OPERATORS: 'operadoraVuelo',
        SEGMENT_DATES: 'fecha',
        DEPARTURE_AIRPORT: 'aeropuertoOrigen',
        ARRIVAL_AIRPORT: 'aeropuertoDestino',
        TOTAL_AVAILABILITY: 'resultadosBusqueda',
        DEPARTURE_TIME: 'horarioSalida',
        ERROR_CODE: 'codigoError',
        INTERNAL_ERROR_CODE: 'subCodigoError',
        ERROR_DESCRIPTION: 'descripcionError',
        MODAL_ID: 'modal',
        INIT_TYPE: 'detalleInicio',
        ANCILLARIES_BOUGHT: 'ancillariesComprados',
        ANCILLARIES_ACTION: 'ancillariesAction',
        ANCILLARIES_SEATS: 'ancillariesAsientos',
        SPEQSINFO : {
            SPEQSTOTALPRICE: 'SpeqsTotalPrice',
            SPEQSTOTAL: 'SpeqsTotal',
            SPEQSBYTYPE: {
                BICYCLE: {
                    SPEQSBICYCLETOTAL: 'SpeqsBycycleTotal',
                    SPEQSBICYCLEPRICE: 'SpeqsBycycleTotalPrice'
                },
                SURFBOARD: {
                    SPEQSSURFBOARDTOTAL: 'SpeqsSurfTotal',
                    SPEQSSURFBOARDPRICE: 'SpeqsSurfTotalPrice'
                },
                SKI_SNOW: {
                    SPEQSSKISNOWTOTAL: 'SpeqsSkiTotal',
                    SPEQSSKISNOWPRICE: 'SpeqsSkiTotalPrice'
                },
                GOLF_EQUIPMENT: {
                    SPEQSGOLFEQUIPMENTTOTAL: 'SpeqsGolfTotal',
                    SPEQSGOLFEQUIPMENTPRICE: 'SpeqsGolfTotalPrice'
                },
                FISHING_EQUIPMENT: {
                    SPEQSFISHINGEQUIPMENTTOTAL: 'SpeqsFishingTotal',
                    SPEQSFISHINGEQUIPMENTPRICE: 'SpeqsFishingTotalPrice'
                },
                SCUBA_DIVING: {
                    SPEQSSCUBADIVINGTOTAL: 'SpeqsScubaTotal',
                    SPEQSSCUBADIVINGPRICE: 'SpeqsScubaTotalPrice'
                }
            },
            SPEQS_HEADER_FORMAT: {
                BICYCLE: 'BICYCLE',
                SURFBOARD: 'SURFBOARD',
                SKISNOW: 'SKI_SNOW',
                GOLFEQUIPMENT: 'GOLF_EQUIPMENT',
                FISHINGEQUIPMENT: 'FISHING_EQUIPMENT',
                SCUBADIVING: 'SCUBA_DIVING'
            }
        },
        BAGGAGESINFO : {
            BAGGAGESTOTALPRICE: 'BaggagesTotalPrice',
            BAGGAGESTOTAL: 'BaggagesTotal',
            BAGGAGESBYTYPE: {
                BAGGAGE15: {
                    BAGGAGES15TOTAL: 'Baggages15Total',
                    BAGGAGES15PRICE: 'Baggages15TotalPrice'
                },
                BAGGAGE23: {
                    BAGGAGES23TOTAL: 'Baggages23Total',
                    BAGGAGES23PRICE: 'Baggages23TotalPrice'
                },
                BAGGAGE32: {
                    BAGGAGES32TOTAL: 'Baggages32Total',
                    BAGGAGES32PRICE: 'Baggages32TotalPrice'
                }
            },
            BAGGAGES_HEADER_FORMAT: {
                BAGGAGE_15: 'BAGGAGE_15',
                BAGGAGE_23: 'BAGGAGE_23',
                BAGGAGE_32: 'BAGGAGE_32'
            }
        },
        SEATSINFO: {
            SEATSTOTALPRICE: 'SeatsTotalPrice',
            SEATSTOTAL: 'SeatsTotal',
            SEATSBYTYPE: {
                XL: {
                    SEATSXLTOTAL: 'SeatsXLTotal',
                    SEATSXLPRICE: 'SeatsXLPrice'
                },
                PROMO: {
                    SEATSPROMOTOTAL: 'SeatsPromoTotal',
                    SEATSPROMOPRICE: 'SeatsPromoPrice'
                },
                EMERGENCY: {
                    SEATSEMERGENCYTOTAL: 'SeatsEmergencyTotal',
                    SEATSEMERGENCYPRICE: 'SeatsEmergencyPrice'
                },
                UPFRONT: {
                    SEATSEUPFRONTTOTAL: 'SeatsUpfrontTotal',
                    SEATSEUPFRONTPRICE: 'SeatsUpfrontPrice'
                },
                PASSENGER_WITH_INFANT: {
                    SEATSEINFANTTOTAL: 'SeatsInfantTotal',
                    SEATSEINFANTPRICE: 'SeatsInfantPrice'
                },
                RESTRICTED_MOBILITY: {
                    SEATSRESTRICTEDMOBILITYTOTAL: 'SeatsRestrictedMobilityTotal',
                    SEATSRESTRICTEDMOBILITYPRICE: 'SeatsRestrictedMobilityPrice'
                }
            },
            SEATS_HEADER_FORMAT: {
                UPFRONT: 'UPFRONT',
                EXTRA_SIZE: 'EXTRA_SIZE',
                EMERGENCY: 'EMERGENCY_EXIT',
                PROMO: 'PROMO',
                INFANT: 'PASSENGER_WITH_INFANT',
                RESTRICTED_MOBILITY: 'RESTRICTED_MOBILITY'
            }
        },
        FLEXIBILITY_INFO: {
            FLEXIBILITY_TOTAL_PRICE : 'flexibilityTotalPrice',
            FLEXIBILTY_TYPE : 'flexibilityType'
        },
        ANCILLARIES_BAGGAGES: 'ancillariesMaletas',
        ANCILLARIES_SPEQS: 'ancillariesEquipajesEspeciales',
        ANCILLARIES_INSURANCES: 'ancillariesSeguros',
        INSURANCE_POLICY: 'Policy',
        INSURANCE_TYPE: 'InsuranceType',
        INSURANCE_TOTAL_PRICE: 'InsuranceTotalPrice',
        INSURANCE_PROVIDER: 'InsuranceProvider',
        BOOKING_CLASS: 'claseReserva',
        UPGRADE_SHOWN: 'upgradingMostrado',
        UPGRADE_SENT: 'upgradingEnviado',
        UPGRADE_TOTAL: 'upgradingImporteMoneda',
        APIS_FULFILLED: 'APIScumplimentados',
        HPBT: 'HPBT',
        DOWNLOAD_FORMAT: 'formatoDescarga',
        VIP_ROOM: 'salaVIP',
        ORDER_KEY: 'claveOrdenacion',
        AVIOS_COINS: 'avios',
        ONE_WAY: 'ida',
        EVENT: 'event',
        EVENT_CATEGORY: 'eventCategory',
        EVENT_ACTION: 'eventAction',
        EVENT_LABEL: 'eventLabel',
        EVENT_FARE_OPTIONS: {
            SEARCH_GENERAL_FARES_ALL_TEXT: 'todas tarifas',
            FARES_FILTER_ECONOMY: 'tarifa mas economica',
            FARES_FILTER_PREMIUM: 'turista premium',
            FARES_FILTER_BUSINESS: 'business class'
        },
        EVENT_INTERESTS_OPTIONS: {
            INTERESTS_FILTER_ALL: 'todos intereses',
            INTERESTS_FILTER_BEACH: 'playa',
            INTERESTS_FILTER_WITHCHILDS: 'familiares',
            INTERESTS_FILTER_CULTURAL: 'cultural',
            INTERESTS_FILTER_ROMANTIC: 'romantica',
            INTERESTS_FILTER_ADVENTURE: 'aventura'
        },
        OUTBOUND_RESULTS: 'resultadosIda',
        INBOUND_RESULTS: 'resultadosVuelta',
        MULTIPLE_TRIP_RESULTS: 'resultadosMultiple',
        TRIP_TYPE: 'tipoVuelo',
        SEARCHED_TRIP: 'trayectoBuscado',
        COUNTRY_TRIP: 'trayectoPais',
        ADVANCE_PURCHASE: 'antelacionCompra',
        DESTINATION_STAY: 'estanciaDestino',
        SEGMENT_HOUR: 'horarioVuelo',
        FARE_NAMES: 'nombreTarifas',
        IB_PLUS_HOLDER: 'titularIberiaPlus',
        CREDITCARD_TYPE: 'tipoTarjeta',
        CURRENCY: 'moneda',
        CHEAPER_FARE: 'tarifaBarata',
        PASSENGER_PRICE: 'precioPax',
        AVIOS_DISCOUNT: 'AVIOSredimidos',
        SEARCH_CITY: 'SearchCity',
        SEARCH_ORIGIN: 'SearchOrigin',
        SEARCH_ORIGIN_NAME: 'SearchOriginName',
        SEARCH_DEST_NAME: 'SearchDestName',
        SEARCH_DEST: 'SearchDest',
        SEARCH_COUNTRY: 'SearchCountry',
        ENTRY_POINT: 'origenBusqueda',
        QUANTITY_ORDER_ITEMS: 'Quantity',
        TOTAL_PRICE: 'precioTotal',
        TOTAL_PRICE_WITHOUT_FEE: 'precioTotalSinTasas',
        TOTAL_PRICE_TAXES: 'precioTasas',
        TOTAL_PRICE_AVIOS: 'aviosUsados',
        TOTAL_PRICE_AVIOS_MONEY: 'precioAviosMoney',
        LARGE_FAMILY: 'familianumerosa',
        RESIDENT: 'residentCode',
        USER_AVIOS: 'userAvios',
        STOPS_NUMBER: 'escalas',
        CABINS: 'cabinas',
        FLIGHTS_NUMBER: 'Identifier',
        VOUCHER: 'voucher',
        PAYMENT_METHOD: 'paymentMethod',
        REDUCED_MOBILITY: 'paxMovilidadReducida',
        NUM_ADDULTS: 'numeroAdultos',
        NUM_CHILDS: 'numeroNinios',
        NUM_INFANTS: 'numeroBebes',
        NUM_SENIOR: 'numeroSeniors',
        NUM_YOUNG: 'numeroJovenes',
        NUM_TENNEAGER: 'numeroAdolescentes',
        HASH_EMAIL: 'hashEID',
        PASSENGER_EMAIL: 'hashEBKI',
        ANCILLARIES_FLEXIBILITY: 'ancillariesFlexibility',
        ANCILLARIES_TOTAL_SEATS: 'totalNumAsientos',
        ANCILLARIES_TOTAL_BAGGAGE: 'totalNumEquipajes',
        ANCILLARIES_TOTAL_SPEQS: 'totalNumEquipajesEspeciales',
        ANCILLARIES_TOTAL_PRICE_SEAT: 'totalCosteAsientos',
        ANCILLARIES_TOTAL_PRICE_BAGGAGE: 'totalCosteEquipaje',
        ANCILLARIES_TOTAL_PRICE_SPEQS: 'totalCosteEquipajeEspeciales',
        ANCILLARIES_INSURANCE_TYPE: 'tipoSeguro',
        ORIGINAL_FLIGHT_DATE: 'fechaOriginal',
        ORIGINAL_DATE_ADVANCE: 'antelaciónCompraOriginal',
        ORIGINAL_DESTINATION_STAY: 'estanciaDestinoOriginal',
        NEW_DATES_RANGE: 'fecha',
        NEW_DESTINATION_STAY: 'estanciaDestino',
        DIFFERENCE_BETWEEN_ORIGINAL_AND_NEW_DATES: 'antelacionCompra',
        SPECIAL_NEEDS: 'paxMovilidadReducida',
        PNR_TYPE: 'tipoPNR',
        FLIGHTS_STATUS: 'estadoVuelos',
        CHANGE_TYPE: 'tipoCambio',
        ISSUE_DATE: 'fechaCompra',
        VOUCHER_DISCOUNT_AMOUNT: 'descuentoBono',
        SPECIAL_MEALS: 'comidaEspecial',
        AVIOS_DISCOUNT_AMOUNT: 'descuentoAvios',
        TOTALTAX: 'precioTotal',
        NOTAX: 'precioTotalSinTasas',
        AIRCRAFT: 'aircraft',
        PROCESS: 'proceso',
        OFFERDEST: 'OfferDest',
        OFFERDESTNAME: 'OfferDestName',
        ORIGINAL_TOTAL_PRICE: 'precioTotalOriginal',
        PERCENT_DISCOUNT: 'porcentajeDescuentos',
        TOTAL_DISCOUNT: 'totalDescuentos',
        DYNAMIC_PRICING: 'DynamicPricing',
        FLASHOFFER: 'flashoffers',
        RESERVE_OFER: 'reservar',
        FLIGHT_RATIO: 'flightRatio',
        DYNAMIC_PRICING_SEAT: 'dynamic_pricing_seat',
        ORDER_ID: 'OrderId',
        OUTBOUND_ROUTE: 'rutaIda',
        RETURN_ROUTE: 'rutaVuelta',
        TYPE_SEARCH: 'tipoBusqueda',
        STEP: 'paso',
        FF_OUTBOUND: 'ffida',
        FF_RETURN: 'ffvuelta',
        OFFERED_CASH_AVIOS: 'cashAviosOfrecido',
        OFFERED_VOUCHER: 'bonoOfrecido',
        USED_CASH_AVIOS: 'cashAviosUsado',
        USED_VOUCHER: 'bonoUsado',
        FLIGHT_TYPE: 'FlightType',
    };
    public static PNR_INFO = {
        PROVIDER: 'provider',
        REFERENCE: 'reference'
    };
    public static DATALAYER_EVENT_TYPES = {
        VIEW: 'view',
        LINK: 'link',
        CLICK: 'click',
        IMPRESSIONS: 'impresiones',
        CLIC: 'clic'
    };
    public static DATALAYER_VALUES = {
        YES: 'SI',
        NO: 'NO',
        WEB_VERSION: 'angularjs',
        WEB_VERSION_CLASSIC: 'clasica',
        INIT_LOCATOR: 'por localizador',
        INIT_IB_PLUS: 'por IB plus',
        FREE: 'gratuito',
        PAYMENT: 'pago',
        BAGGAGES: 'Maletas',
        SEATS: 'Asientos',
        ASSURANCES: 'Seguros',
        PDF_FORMAT: 'PDF',
        QR_FORMAT: 'QR',
        PASSBOOK_FORMAT: 'Passbook',
        OFFERED: 'Ofertados',
        EMITED: 'Emitidos',
        SEGMENT_OPEN: 'OPEN',
        EXCLUSIVE_PROMOS_EVENT_CATEGORY: 'Promociones exclusivas',
        AVIOS_EVENT_CATEGORY: 'fly with avios',
        PARTNERS_AND_PLANS_EVENT_CATEGORY: 'Partners y Planes',
        LET_ME_KNOW_PAGE: 'pagina aviso',
        NOT_AVAIBILITY_ALERT: 'alerta no disponibilidad vuelos',
        PRINTS: 'impresiones',
        CLICK_ON_MAIL: 'click avisar al email',
        ALERT_EMAIL_OK: 'aviso email confirmado',
        ALERT_EMAIL_ERROR: 'aviso email error',
        ORDER_KEYS: {
            TIME_ASC: 'Horario Ascendente',
            TIME_DESC: 'Horario Descendente',
            DURATION_ASC: 'Duración Ascendente',
            DURATION_DESC: 'Duración Descendente',
            CABINS_AND_PRICE_ASC: 'Cabinas y precios Ascendente',
            CABINS_AND_PRICE_DESC: 'Cabinas y precios Descendente'
        },
        ORDER_EVENT_OUTBOUND: 'ordenarIdaPor',
        ORDER_EVENT_INBOUND: 'ordenarVueltaPor',
        ANCILLARIES_EVENT: 'addAncillaries',
        ONE_WAY_TRIP: 'OW',
        RETURN_TRIP: 'RT',
        MULTIPLE_TRIP: 'MT',
        FARE_FAMILY_STANDARD: 'STANDARD',
        CABIN_FAMILY_STANDARD: 'STANDARD',
        INBOUND: 'vuelta',
        OUTBOUND: 'ida',
        DEPARTURE: 'IDA',
        RETURN: 'VUELTA',
        PASSENGERS_TYPES: {
            ADULT: 'ADT',
            CHILD: 'CHD',
            INFANT: 'INF',
            SENIOR: 'YCD',
            YOUTH: 'YTH',
            YOUNG_ADULT: 'BNN'
        },
        FLEXIBLE: 'flexibilizado',
        NON_FLEXIBLE: 'no_flexibilizado',
        DISRUPTED: 'disruptado',
        PAYMENT_METHODS: {
            VOUCHER: 'fullVoucher',
            CASH_AVIOS: 'cash&Avios',
            CASH_VOUCHER: 'cash&Voucher',
            CASH: 'cash'
        },
        PURCHASE_CATEGORY: {
            DIRECT: 'Compra directa',
            ON_HOLD: 'Reserva On-Hold',
            ON_HOLD_CONFIRMATION: 'Confirmación On-Hold'
        },
        FLIGHT_RATIO_TYPES: {
            LONG: 'Largo Radio',
            MEDIUM: 'Medio Radio',
            SHORT: 'Corto Radio'
        },
        CALENDAR: 'Calendario'
    };
    public static SEGMENT_TYPES = {
        OPEN: 'OPEN',
        CONFIRMED: 'CONFIRMED'
    };
    public static PASSENGERS_TYPES = {
        ADULT: 'ADULT',
        CHILD: 'CHILD',
        INFANT: 'INFANT'
    };
    public static SEGMENT_CABIN_PRIORITY = {
        F: 1,
        B: 2,
        E: 3,
        R: 4,
        T: 5
    };
    public static DATALAYER_ELEMENT_CLICKED = {
        LINK: 'click link',
        BUTTON: 'click button'
    };
    public static DATALAYER_ECOMMERCE = {
        CURRENCY: 'currency',
        TRANSACTION: 'transaction',
        PRODUCTS: 'products',
        REVENUE: 'revenue',
        SHIPPING: 'shipping',
        TYPE_FLIGHT: 'flight',
        OH_CONFIRMATION: 'confirmacion onhold'
    };
    public static DATALAYER_PREFIX = {
        AGENTS: 'agencias_'
    };
    public static DATALAYER_LABEL = {
        CONTINUAR: 'continuar'
    };
    public static DATALAYER_ANCILLARIES = {
        ANCILLARIES: 'ancillaries'
    };
    public static DATALAYER_FLASH_OFFERS = {
        PROCESS: 'flashOffers'
    };
    public static FLIGHT_CODE_TYPE = {
        ONE_WAY: 'OW',
        ROUND_TRIP: 'RT',
        MULTI_TRAJECT: 'MT'
    };
    public static DATALAYER_VOLUNTARYCHANGES = {
        PRICE_PASSANGER: 'precioPax',
        STOPOVER_FLIGHT: 'escalas',
        BOOKING_CLASS: 'claseReserva',
        FLIGHT_TIME: 'horarioVuelo',
        FARE_NAMES: 'nombreTarifas',
        SEGMENT_OPERATORS: 'operadoraVuelo',
        TOTAL_PRICE: 'precioTotal',
        TOTAL_PRICE_WITHOUT_TAX: 'precioTotalSinTasas',
        CHEAP_FARE: 'tarifaBarata',
        IDENTIFIER: 'Identifier',
        CABINES: 'cabinas',
        COIN: 'moneda',
        IBERIAPLUS_HOLDER: 'titularIberiaPlus',
        ORIGIN_DESTINATIONS: 'trayectoAeropuerto',
        SEARCHED_PATH: 'trayectoBuscado',
        COUNTRY_PATH: 'trayectoPais'
    };
    public static QUADRIGAMS = {
        LANDING_FLASH: 'FLASHO',
        DETAILS_FLASH: 'FLASHD',
        SHUTTLE_HOME: 'PAHOME',
        SHUTTLE_PASSENGERS: 'PAHMPA',
        SHUTTLE_PASSENGERS_CODE: 'PAAIRP',
        SHUTTLE_REDEMPTION_PASSENGERS: 'RPAAIRP',
        SHUTTLE_PAYMENTS: 'PAPURC',
        SHUTTLE_REDEMPTION_PAYMENTS: 'RPAPURC',
        SHUTTLE_CONFIRMATION: 'PABKCF',
        SHUTTLE_REDEMPTION_CONFIRMATION: 'RPABKCF',
        CKI_SESSION_EXPIRED: 'CKIEXP',
        MMB_SESSION_EXPIRED: 'MMBEXP'
    };
    public static LANG: 'es';
    public static MARKET: 'ES';
    public static DISCOUNT_TYPES = {
        DYNAMIC_PRICING: 'DYNAMIC_PRICING'
    };
    public static SURE_MODAL = {
        EVENT_CATEGORY: 'Guardado datos',
        EVENT_ACTION: 'clic',
        EVENT_LABEL_SAVE: 'Guardar',
        EVENT_LABEL_DONT_SAVE: 'No guardar'
    };
    public static SAVE_ACCEPT_LITERALS = {
        EVENT_ACTION: 'confirmacion',
        EVENT_LABEL_OK: 'OK',
        EVENT_LABEL_KO: 'KO'
    };
    public static FLOWS = {
        SHUTTLE: 'ibshuttle',
        PASSENGERS: 'ibairp',
        ANCILLARIES: 'ibcmtv',
        PAYMENTS: 'ibpurc',
        CONFIRMATION: 'confirmation'
    };
    public static FLIGHT_RATIO_TYPES = {
        LONG: 'Largo Radio',
        MEDIUM: 'Medio Radio',
        SHORT: 'Corto Radio'
    };
    public static SHUTTLE_OPEN: 'IBOPEN';
    public static DATALAYER_FLOW_CKI = {
        PROCESS: 'checkin',
        PROCESS_DUPLICATE: 'checkin duplicados',
        PROCESS_DESINVOICING: 'desfacturar',
        IBCOSE: 'landing',
        IBCOSEII: 'listado pnrs',
        IBCOAC: 'recuperacion',
        IBCOACPA: 'recuperacion puente aereo',
        CKDANG: 'articulos peligrosos',
        CKIANC: 'ancillaries',
        IBCOAC2: 'apis',
        IBFNPA: 'puente aereo',
        IBFNCOPA: 'vuelo puente aereo',
        CKIANCUPP: 'upg',
        IBCKIPURC: 'pago',
        CKIBIO: 'biometria',
        IBCOBP: 'tarjeta de embarque',
        IBCKICF: 'confirmacion',
        IBECCF: 'confirmacion',
        IBCOED: 'recuperacion',
        UNCOAC: 'inicio',
        UNCOSE: 'recuperacion',
        UNCONF: 'confirmacion'
    };
    public static DATALAYER_VIEWS = {
        DISPO: 'disponibilidad',
        DISPO_CALENDAR: 'calendarioDisponibilidad',
        FARE: 'tarifa',
        PASSENGERS: 'pasajeros',
        ANCILLARIES: 'ancillaries',
        PAYMENTS: 'pago',
        CONFIRMATION: 'confirmacion',
        ONHOLD_PAYMENT: 'pago',
        ONHOLD_CONFIRMATION: 'confirmacion',
        ALP: 'coche_hotel'
    };
    public static EVENTS_ECOMMERCE = {
        VIEW_ITEM_LIST: 'view_item_list',
        SELECT_ITEM: 'select_item',
        ADD_TO_CART: 'add_to_cart',
        BEGIN_CHECKOUT: 'begin_checkout',
        ADD_SHIPPING_INFO: 'add_shipping_info',
        REMOVE_FROM_CART: 'remove_from_cart'
    };
    public static GASTRONOMIC_EVENT_CATEGORY_VALUES  = {
	    GASTRONOMIC_PROPOSAL: 'propuesta gastronómica',
    };
    public static GASTRONOMIC_EVENT_LABEL_VALUES = {
        PREORDER: 'realizar pedido',
        SPECIAL_MEALS: 'seleccionar',
        SPECIAL_MEALS_SELECTED: 'modificar',
        DIGITAL_MENU :'ver menu',
        ONBOARD_MENU :'descargar carta',
        TAB_FLIGHT: 'tab vuelo',
        TAB_OTHER_FLIGHTS: 'otros vuelos'
    };
    public static GASTRONOMIC_DIGITAL_DATA_STEPS = {
        PREORDER: 'preorder',
        SPECIAL_MEALS: 'comida',
        DIGITAL_MENU :'digital menu',
        ONBOARD_MENU :'buyonboard',
    };
    public static DatalayerGeneralConstants = {
        LANGUAGE: 'Language',
        MARKET: 'Market',
        USER_STATE: 'UserStatus',
        USER_LEVEL: 'UserLevel',
        USER_ID: 'UserID',
        ClientID: 'ClientID',
        USER_SEGMENT: 'UserSegment',
        CODE_TRACKING: 'UserCUG',
        AVIOS_COINS: 'Avios',
        USER_AVIOS: 'UserAvios',
        TOTAL_PRICE_AVIOS: 'AviosUsed',
        HASH_EMAIL: 'HashEID',
        PASSENGER_EMAIL: 'HashEBKI',
        DEEPLINK: 'Deeplink',
        PROCESS: 'Process',
        STEP: 'Step',
        QUADRIGAM: 'Quadrigam',
        CODE: 'TrackingCode',
        CURRENCY: 'Currency',
        WEB_VERSION: 'VersionWeb',
        WEB_MODE: 'ModeWeb',
        REFERENCE: 'Reference',
        VOUCHER_AMOUNT: 'VoucherAmount',
        PRODUCT: 'Product',
        ORDER_ID: 'OrderId',
        PAYMENT_METHOD: 'PaymentMethod',
        VOUCHER_CODE: 'VoucherCode',
        ORIGIN_DESTINATIONS: 'AirportSeg',
        UPG_TYPE: 'UpgType',
        BOOKING_CLASS: 'BookingClass',
        EVENT_CATEGORY: 'eventCategory',
        EVENT_ACTION: 'eventAction',
        EVENT_LABEL: 'eventLabel',
        EVENT_NAME: 'eventName',
        EVENT_NAME_INTERACTION: 'interaccion',
        EVENT_LABEL_IMPRESSION: 'impresion',
        EVENT_LABEL_CLICK: 'click',
        CASH_AVIOS_USED: 'CashAviosUsed',
        VOUCHER_USED: 'VoucherUsed',
        VOUCHER_SHOWN: 'VoucherShown',
        INSURANCE_TYPE: 'InsuranceType',
        QUANTITY: 'Quantity',
        ROL_CIP: 'RolCIP',
        VOUCHER_DISCOUNT: 'VoucherDiscount'
    };
    public static MMB_UN_UNTK_PROCESSES = {
        UN: 'involuntario sin alternativa',
        UNTK: 'involuntario con alternativa',
    };
    public static DIGITAL_DATA_VALUES = {
        YES: 'SI',
        NO: 'NO'
    };
};
